/**
 * 出力ログページ用のスクリプト
 */

if (is_route('export_logs.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        export_logs_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.export_logs_event_set = function() {

    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#export_logs_search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });

    /*---- 検索条件変更時 ----*/

    // 入力日時（開始）変更時
    $(document).on('change', '#search-form-started_at', function () {
        dateRange_changeStartedAt(this, '#search-form-ended_at', 30);
    });

    // 入力日時（終了）変更時
    $(document).on('change', '#search-form-ended_at', function () {
        dateRange_changeEndedAt(this, '#search-form-started_at', 30);
    });

}
